import { useContext, useEffect, useMemo, useRef, useState } from 'react'
import ReportContent from '@comp/tableDrawer/reportContent'
import ReportHeader from '@comp/tableDrawer/reportHeader'
import { AcceptProvider, GetAllProvider, RejectProvider } from '@/api/endpoints'
import { useUpdate } from '@/api/hooks'
import { useNavigate } from 'react-router-dom'
import { DomainContext } from '@context/DomainContext'
import { PROVIDER_REQUEST_STATUS } from '@/data/status'
import ReportSearch from '@comp/tableDrawer/reportSearch'
import ActionBtn from '@comp/ActionBtn'
import BaseBtn from '@/components/tableDrawer/TableItems/components/tableActions/BaseBtn'
import TextPopup from '@/components/popups/TextPopup'

const Pending = ({ columns, TabsSection, reqID }) => {

    const openInsertModal = useRef()
    const [rejectId, setRejectId] = useState(null)
    const rejectModal = useRef()

    const { setCustomSearchData } = useContext(DomainContext)

    const { onUpdate: onAccept } = useUpdate(AcceptProvider)
    const { onUpdate: onReject } = useUpdate(RejectProvider)

    const navigate = useNavigate()

    const tableColumns = useMemo(() => [...columns
        ,
    {
        Header: 'details',
        Cell: ({ row: { original } }) => {
            return (
                <>
                    <BaseBtn action={"show-details"} onApply={() => navigate(`/panel/request-details/${original?.id}`)} icon={"solar:eye-outline"} className="details-info" reqAction="canAdd" />
                </>
            )
        }
    }
        ,
    {
        id: 'action',
        Cell: ({ row: { original } }) => {
            return (
                <>
                    <ActionBtn onApply={() => onAccept(original?.id)} title="accept" className="accept-btn" reqAction="canAdd" icon={"si:check-fill"} />
                    <ActionBtn onApply={() => handleReject(original?.id)} title="reject" className="reject-btn" reqAction="canAdd" icon={"codex:cross"} />
                </>
            )
        },
    },
    ], [])


    const handleReject = (id) => {
        rejectModal.current.click()
        setRejectId(id)
    }

    const rejectAction = (text) => {
        onReject(rejectId , {note:text})
        rejectModal.current.click()
    }

    return (
        <>
            <TextPopup textRef={rejectModal} onApply={rejectAction} />

            <ReportContent tableAPI={GetAllProvider} columns={tableColumns}>
                <ReportHeader ApplyAction={openInsertModal} >
                    <ReportSearch />
                </ReportHeader>
                <TabsSection />

            </ReportContent>
        </>
    )
}

export default Pending